import { BusinessModalFilters } from '@partoohub/api-client';

export const isBusinessIdInFilteredBusinesses = (
    filteredBusinesses: BusinessModalFilters,
    businessId: string,
): boolean => {
    const includedBusinessesListIds = filteredBusinesses.business__in?.split(',') ?? [];
    const excludedBusinessesListIds = filteredBusinesses.business__notin?.split(',') ?? [];

    return (
        (includedBusinessesListIds.length === 0 && excludedBusinessesListIds.length === 0) ||
        (includedBusinessesListIds.length > 0 && includedBusinessesListIds.includes(businessId)) ||
        (excludedBusinessesListIds.length > 0 && !excludedBusinessesListIds.includes(businessId))
    );
};
